import React from 'react';

const DagobaStars = (width: number) => {
  return (
    <svg version="1.1" viewBox="0 0 512 96"  style={{width: width}} xmlSpace="preserve">
      <style type="text/css">
        {`.st0{fill:#4269AF;}
          .st1{fill:#BABABA;}
          .st2{fill:#FFFFFF;}`}
      </style>
      <g>
        <rect id="Rectangle-path" y="0" className="st0" width="96" height="96" />
        <rect x="104" y="0" className="st0" width="96" height="96" />
        <rect x="208" y="0" className="st0" width="96" height="96" />
        <rect x="312" y="0" className="st0" width="96" height="96" />
        <g id="Half" transform="translate(416.000000, 0.000000)">
          <rect x="48" y="0" className="st1" width="48" height="96" />
          <rect y="0" className="st0" width="62.8" height="96" />
        </g>
      </g>
      <polygon
        className="st2"
        points="48,15.8 58.1,39.5 81.8,39.5 64.9,56.5 71.7,80.2 48,66.6 24.3,80.2 31,56.5 14.1,39.5 37.8,39.5"
      />
      <polygon
        className="st2"
        points="152.8,15.8 163,39.5 186.7,39.5 169.8,56.5 176.5,80.2 152.8,66.6 129.1,80.2 135.9,56.5 119,39.5
          142.7,39.5"
      />
      <polygon
        className="st2"
        points="256,15.8 266.1,39.5 289.8,39.5 272.9,56.5 279.7,80.2 256,66.6 232.3,80.2 239,56.5 222.1,39.5
          245.8,39.5"
      />
      <polygon
        className="st2"
        points="361.1,15.8 371.3,39.5 395,39.5 378,56.5 384.8,80.2 361.1,66.6 337.4,80.2 344.2,56.5 327.2,39.5
          350.9,39.5"
      />
      <polygon
        className="st2"
        points="463.9,15.8 474,39.5 497.7,39.5 480.8,56.5 487.6,80.2 463.9,66.6 440.2,80.2 447,56.5 430,39.5
          453.7,39.5"
      />
    </svg>
  );
};

export default DagobaStars;
